import _ from 'lodash';
import { renderMarkdown } from '@achievable-me/tundra-wizard/markdown';
import { slugify } from '$lib/slugify';

const getMarkdown = (prompt) => {
  if (!prompt) {
    return '';
  }

  if (_.isString(prompt)) {
    return prompt;
  }

  return prompt.given;
};

export const parsePrompt = ({ code, prompt }) => {
  const markdown = getMarkdown(prompt) || '';
  const { rendered } = renderMarkdown(markdown);
  const promptHtml = rendered || '';
  const promptText = promptHtml.replace(/<[^>]+>/g, '').trim();

  const title = `Quiz [${code}]: ${promptText}`;
  const truncatedTitle = _.truncate(title, { length: 65 });

  const slug = slugify(promptText);
  const truncatedSlug = _.truncate(slug, { length: 65 });

  return {
    title,
    slug,
    truncatedTitle,
    truncatedSlug,
  };
};
